var __webpack_modules__ = {
    "./src/md5.js": function(module) {
        let hexcase = 0;
        let b64pad = '';
        function hex_md5(s) {
            return rstr2hex(rstr_md5(str2rstr_utf8(s)));
        }
        function b64_md5(s) {
            return rstr2b64(rstr_md5(str2rstr_utf8(s)));
        }
        function any_md5(s, e) {
            return rstr2any(rstr_md5(str2rstr_utf8(s)), e);
        }
        function hex_hmac_md5(k, d) {
            return rstr2hex(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
        }
        function b64_hmac_md5(k, d) {
            return rstr2b64(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
        }
        function any_hmac_md5(k, d, e) {
            return rstr2any(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)), e);
        }
        function md5_vm_test() {
            return hex_md5('abc').toLowerCase() == '900150983cd24fb0d6963f7d28e17f72';
        }
        function rstr_md5(s) {
            return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
        }
        function rstr_hmac_md5(key, data) {
            let bkey = rstr2binl(key);
            if (bkey.length > 16) bkey = binl_md5(bkey, key.length * 8);
            const ipad = Array(16), opad = Array(16);
            for(let i = 0; i < 16; i++){
                ipad[i] = bkey[i] ^ 0x36363636;
                opad[i] = bkey[i] ^ 0x5c5c5c5c;
            }
            const hash = binl_md5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
            return binl2rstr(binl_md5(opad.concat(hash), 512 + 128));
        }
        function rstr2hex(input) {
            try {
                hexcase;
            } catch (e) {
                hexcase = 0;
            }
            const hex_tab = hexcase ? '0123456789ABCDEF' : '0123456789abcdef';
            let output = '';
            let x;
            for(let i = 0; i < input.length; i++){
                x = input.charCodeAt(i);
                output += hex_tab.charAt(x >>> 4 & 0x0f) + hex_tab.charAt(x & 0x0f);
            }
            return output;
        }
        function rstr2b64(input) {
            try {
                b64pad;
            } catch (e) {
                b64pad = '';
            }
            const tab = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
            let output = '';
            const len = input.length;
            for(let i = 0; i < len; i += 3){
                const triplet = input.charCodeAt(i) << 16 | (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) | (i + 2 < len ? input.charCodeAt(i + 2) : 0);
                for(let j = 0; j < 4; j++){
                    if (i * 8 + j * 6 > input.length * 8) output += b64pad;
                    else output += tab.charAt(triplet >>> 6 * (3 - j) & 0x3f);
                }
            }
            return output;
        }
        function rstr2any(input, encoding) {
            const divisor = encoding.length;
            let i, j, q, x, quotient;
            let dividend = Array(Math.ceil(input.length / 2));
            for(i = 0; i < dividend.length; i++){
                dividend[i] = input.charCodeAt(i * 2) << 8 | input.charCodeAt(i * 2 + 1);
            }
            const full_length = Math.ceil(input.length * 8 / (Math.log(encoding.length) / Math.log(2)));
            const remainders = Array(full_length);
            for(j = 0; j < full_length; j++){
                quotient = Array();
                x = 0;
                for(i = 0; i < dividend.length; i++){
                    x = (x << 16) + dividend[i];
                    q = Math.floor(x / divisor);
                    x -= q * divisor;
                    if (quotient.length > 0 || q > 0) quotient[quotient.length] = q;
                }
                remainders[j] = x;
                dividend = quotient;
            }
            let output = '';
            for(i = remainders.length - 1; i >= 0; i--)output += encoding.charAt(remainders[i]);
            return output;
        }
        function str2rstr_utf8(input) {
            let output = '';
            let i = -1;
            let x, y;
            while(++i < input.length){
                x = input.charCodeAt(i);
                y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
                if (x >= 0xd800 && x <= 0xdbff && y >= 0xdc00 && y <= 0xdfff) {
                    x = 0x10000 + ((x & 0x03ff) << 10) + (y & 0x03ff);
                    i++;
                }
                if (x <= 0x7f) output += String.fromCharCode(x);
                else if (x <= 0x7ff) output += String.fromCharCode(0xc0 | x >>> 6 & 0x1f, 0x80 | x & 0x3f);
                else if (x <= 0xffff) output += String.fromCharCode(0xe0 | x >>> 12 & 0x0f, 0x80 | x >>> 6 & 0x3f, 0x80 | x & 0x3f);
                else if (x <= 0x1fffff) output += String.fromCharCode(0xf0 | x >>> 18 & 0x07, 0x80 | x >>> 12 & 0x3f, 0x80 | x >>> 6 & 0x3f, 0x80 | x & 0x3f);
            }
            return output;
        }
        function str2rstr_utf16le(input) {
            let output = '';
            for(let i = 0; i < input.length; i++)output += String.fromCharCode(input.charCodeAt(i) & 0xff, input.charCodeAt(i) >>> 8 & 0xff);
            return output;
        }
        function str2rstr_utf16be(input) {
            let output = '';
            for(let i = 0; i < input.length; i++)output += String.fromCharCode(input.charCodeAt(i) >>> 8 & 0xff, input.charCodeAt(i) & 0xff);
            return output;
        }
        function rstr2binl(input) {
            const output = Array(input.length >> 2);
            for(var i = 0; i < output.length; i++)output[i] = 0;
            for(var i = 0; i < input.length * 8; i += 8)output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
            return output;
        }
        function binl2rstr(input) {
            let output = '';
            for(let i = 0; i < input.length * 32; i += 8)output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
            return output;
        }
        function binl_md5(x, len) {
            x[len >> 5] |= 0x80 << len % 32;
            x[(len + 64 >>> 9 << 4) + 14] = len;
            let a = 1732584193;
            let b = -271733879;
            let c = -1732584194;
            let d = 271733878;
            for(let i = 0; i < x.length; i += 16){
                const olda = a;
                const oldb = b;
                const oldc = c;
                const oldd = d;
                a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
                d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
                c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
                b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
                a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
                d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
                c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
                b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
                a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
                d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
                c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
                b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
                a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
                d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
                c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
                b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
                a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
                d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
                c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
                b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
                a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
                d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
                c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
                b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
                a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
                d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
                c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
                b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
                a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
                d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
                c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
                b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
                a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
                d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
                c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
                b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
                a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
                d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
                c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
                b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
                a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
                d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
                c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
                b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
                a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
                d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
                c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
                b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
                a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
                d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
                c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
                b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
                a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
                d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
                c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
                b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
                a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
                d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
                c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
                b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
                a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
                d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
                c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
                b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
                a = safe_add(a, olda);
                b = safe_add(b, oldb);
                c = safe_add(c, oldc);
                d = safe_add(d, oldd);
            }
            return Array(a, b, c, d);
        }
        function md5_cmn(q, a, b, x, s, t) {
            return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
        }
        function md5_ff(a, b, c, d, x, s, t) {
            return md5_cmn(b & c | ~b & d, a, b, x, s, t);
        }
        function md5_gg(a, b, c, d, x, s, t) {
            return md5_cmn(b & d | c & ~d, a, b, x, s, t);
        }
        function md5_hh(a, b, c, d, x, s, t) {
            return md5_cmn(b ^ c ^ d, a, b, x, s, t);
        }
        function md5_ii(a, b, c, d, x, s, t) {
            return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
        }
        function safe_add(x, y) {
            const lsw = (x & 0xffff) + (y & 0xffff);
            const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
            return msw << 16 | lsw & 0xffff;
        }
        function bit_rol(num, cnt) {
            return num << cnt | num >>> 32 - cnt;
        }
        module.exports = {
            encrypt: hex_md5
        };
    }
};
var __webpack_module_cache__ = {};
function __webpack_require__(moduleId) {
    var cachedModule = __webpack_module_cache__[moduleId];
    if (cachedModule !== undefined) {
        return cachedModule.exports;
    }
    var module = __webpack_module_cache__[moduleId] = {
        exports: {}
    };
    __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    return module.exports;
}
(()=>{
    __webpack_require__.n = function(module) {
        var getter = module && module.__esModule ? function() {
            return module['default'];
        } : function() {
            return module;
        };
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = function(exports, definition) {
        for(var key in definition){
            if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
                Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            }
        }
    };
})();
(()=>{
    __webpack_require__.o = function(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    };
})();
;
Messenger.decorate = function(instance) {
    instance.messenger = new Messenger();
    instance.addEventListener = function(eventName, method) {
        instance.messenger.addEventListener(eventName, method);
    };
    instance.dispatchEvent = function(eventName, data, context) {
        instance.messenger.dispatchEvent(eventName, data, context);
    };
    instance.removeEventListener = function(eventName, targetMethod) {
        instance.messenger.removeEventListener(eventName, targetMethod);
    };
};
function Messenger() {
    this.events = {};
}
Messenger.prototype.killAllListeners = function(eventName) {
    if (this.events[eventName]) {
        this.events[eventName] = [];
    } else {
        return false;
    }
};
Messenger.prototype.destroy = function() {
    this.events = {};
};
Messenger.prototype.dispatchEvent = function(eventName, data, context) {
    if (this.events[eventName]) {
        this.events[eventName].forEach((eventHandler)=>{
            eventHandler.call(context, data);
        });
    }
};
Messenger.prototype.addEventListener = function(eventName, method) {
    if (!method) {
        return false;
    }
    if (!this.events[eventName]) {
        this.events[eventName] = [];
    }
    this.events[eventName].push(method);
    return method;
};
Messenger.prototype.removeEventListener = function(eventName, targetMethod) {
    if (this.events[eventName]) {
        const eventHandlers = this.events[eventName];
        const removalQueue = [];
        this.events[eventName].forEach((eventHandler, index)=>{
            if (eventHandler === targetMethod) {
                removalQueue.push(index);
            }
        });
        if (removalQueue.length > 0) {
            removalQueue.forEach((element)=>{
                eventHandlers.splice(element, 1);
            });
        }
    }
};
const messenger = Messenger;
;
const message_bus = new messenger();
;
function UploadResult() {
    this.xml = undefined;
    this.isError = true;
    this.token = undefined;
    this.filename = '';
    this.fileId = -1;
}
UploadResult.prototype.parseXML = function(xml) {
    const parser = new DOMParser();
    this.xml = parser.parseFromString(xml, 'application/xml');
    this.isError = !!(this.xml.querySelector('error') && this.xml.querySelector('error').children && this.xml.querySelector('error').children.length);
    if (!this.isError) {
        this.pullData();
    }
};
UploadResult.prototype.pullData = function() {
    const resultOk = this.xml.querySelector('result_ok');
    if (resultOk) {
        this.token = resultOk.querySelector('token') && resultOk.querySelector('token').textContent;
        this.fileId = resultOk.querySelector('filename') && resultOk.querySelector('filename').textContent;
        this.filename = resultOk.querySelector('origFilename') && resultOk.querySelector('origFilename').textContent;
    }
};
UploadResult.prototype.asEntryParams = function() {
    return {
        entry1_name: this.filename,
        entry1_filename: this.fileId,
        entry1_realFilename: this.filename
    };
};
const upload_result = UploadResult;
var md5 = __webpack_require__("./src/md5.js");
var md5_default = __webpack_require__.n(md5);
;
function signature_builder(params) {
    let names = [];
    for(const prop in params){
        names.push(prop);
    }
    names = names.sort();
    let s = '';
    names.forEach((element)=>{
        s += element;
        s += params[element];
    });
    return md5_default().encrypt(s);
}
;
function url_params(params) {
    let queryUrl = '?';
    for(const prop in params){
        queryUrl += prop + '=' + encodeURIComponent(params[prop]) + '&';
    }
    queryUrl = queryUrl.substring(0, queryUrl.length - 1);
    return queryUrl;
}
;
function isPresent(passed, name) {
    return passed && passed[name] !== undefined;
}
function defaults(name, options, passed) {
    if (isPresent(passed, name)) {
        options[name] = passed[name];
    }
}
;
function K5Options() {}
K5Options.prototype.setOptions = function(options) {
    this.mergeDefaults(options);
};
K5Options.prototype.mergeDefaults = function(options) {
    this.allowedMediaTypes = [
        'video',
        'audio'
    ];
    this.sessionUrl = '/api/v1/services/kaltura_session';
    this.uploadUrl = '';
    this.entryUrl = '';
    this.uiconfUrl = '';
    this.entryDefaults = {
        partnerData: "{'context_code': 'some_course_num', 'root_account'_id':1}",
        conversionProfile: 2,
        source: 1,
        kshow_id: -1,
        quick_edit: true
    };
    defaults('allowedMediaTypes', this, options);
    defaults('sessionUrl', this, options);
    defaults('uploadUrl', this, options);
    defaults('entryUrl', this, options);
    defaults('uiconfUrl', this, options);
    defaults('partnerData', this.entryDefaults, options.entryDefaults);
    defaults('conversionProfile', this.entryDefaults, options.entryDefaults);
    defaults('source', this.entryDefaults, options.entryDefaults);
    defaults('kshow_id', this.entryDefaults, options.entryDefaults);
    defaults('quick_edit', this.entryDefaults, options.entryDefaults);
};
K5Options.prototype.asEntryParams = function() {
    return {
        entry1_partnerData: this.entryDefaults.partnerData,
        entry1_conversionProfile: this.entryDefaults.conversionProfile,
        entry1_source: this.entryDefaults.source,
        kshow_id: this.entryDefaults.kshow_id,
        quick_edit: this.entryDefaults.quick_edit
    };
};
const k5_options = new K5Options();
;
function KalturaRequestBuilder() {
    this.settings, this.file;
    this.xhr;
}
KalturaRequestBuilder.id = 1;
KalturaRequestBuilder.prototype.createRequest = function() {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', this.createUrl());
    xhr.responseType = 'text';
    return xhr;
};
KalturaRequestBuilder.prototype.createFormData = function() {
    const formData = new FormData();
    formData.append('Filename', this.file.name);
    formData.append('Filedata', this.file);
    formData.append('Upload', 'Submit Query');
    return formData;
};
KalturaRequestBuilder.prototype.createFileId = function() {
    KalturaRequestBuilder.id += 1;
    return Date.now().toString() + KalturaRequestBuilder.id.toString();
};
KalturaRequestBuilder.prototype.createUrl = function() {
    const config = this.settings.getSession();
    config.filename = this.createFileId();
    config.kalsig = this.createSignature();
    return k5_options.uploadUrl + url_params(config);
};
KalturaRequestBuilder.prototype.createSignature = function() {
    return signature_builder(this.settings.getSession());
};
KalturaRequestBuilder.prototype.buildRequest = function(settings, file) {
    this.settings = settings;
    this.file = file;
    return this.createRequest();
};
KalturaRequestBuilder.prototype.getFile = function() {
    return this.file;
};
KalturaRequestBuilder.prototype.getSettings = function() {
    return this.settings;
};
const kaltura_request_builder = KalturaRequestBuilder;
;
function Uploader() {
    this.xhr = new XMLHttpRequest();
    this.uploadResult = new upload_result();
}
Uploader.prototype.isAvailable = function() {
    return !!this.xhr.upload;
};
Uploader.prototype.send = function(session, file) {
    const kRequest = new kaltura_request_builder();
    this.xhr = kRequest.buildRequest(session, file);
    this.addEventListeners();
    this.xhr.send(kRequest.createFormData());
};
Uploader.prototype.addEventListeners = function() {
    this.xhr.upload.addEventListener('progress', this.eventProxy.bind(this.xhr));
    this.xhr.upload.addEventListener('load', this.eventProxy.bind(this.xhr));
    this.xhr.upload.addEventListener('error', this.eventProxy.bind(this.xhr));
    this.xhr.upload.addEventListener('abort', this.eventProxy.bind(this.xhr));
    this.xhr.onload = this.onload.bind(this);
};
Uploader.prototype.onload = function(event) {
    this.uploadResult.parseXML(this.xhr.response);
    const resultStatus = this.uploadResult.isError ? 'error' : 'success';
    message_bus.dispatchEvent('Uploader.' + resultStatus, this.uploadResult);
};
Uploader.prototype.eventProxy = function(event) {
    const name = 'Uploader.' + event.type;
    message_bus.dispatchEvent(name, event, this);
};
const uploader = Uploader;
;
function KalturaSession() {
    this.ks = '';
    this.subp_id = '';
    this.partner_id = '';
    this.uid = '';
    this.serverTime = 0;
}
KalturaSession.prototype.setSession = function(obj) {
    if (obj) {
        defaults('ks', this, obj);
        defaults('subp_id', this, obj);
        defaults('partner_id', this, obj);
        defaults('uid', this, obj);
        defaults('serverTime', this, obj);
        defaults('ui_conf_id', this, obj);
    }
};
KalturaSession.prototype.getSession = function() {
    return {
        ks: this.ks,
        subp_id: this.subp_id,
        partner_id: this.partner_id,
        uid: this.uid,
        serverTime: this.serverTime,
        ui_conf_id: this.ui_conf_id
    };
};
KalturaSession.prototype.asEntryParams = function() {
    return this.getSession();
};
const kaltura_session = KalturaSession;
;
function object_merge(objs) {
    if (!objs) {
        return objs;
    }
    const combined = {};
    objs = objs.reverse();
    objs.forEach((obj)=>{
        for(const prop in obj){
            combined[prop] = obj[prop];
        }
    });
    return combined;
}
;
function EntryService() {}
EntryService.prototype.addEntry = function(allParams) {
    this.formData = object_merge(allParams);
    this.createEntryRequest();
};
EntryService.prototype.createEntryRequest = function() {
    const data = this.formData;
    data.kalsig = signature_builder(data);
    this.xhr = new XMLHttpRequest();
    this.xhr.open('GET', k5_options.entryUrl + url_params(data));
    this.xhr.requestType = 'xml';
    this.xhr.onload = this.onEntryRequestLoaded.bind(this);
    this.xhr.send(data);
};
EntryService.prototype.parseRequest = function(xml) {
    const parser = new DOMParser();
    const parsedXml = parser.parseFromString(xml, 'application/xml');
    const ent = parsedXml.querySelector('result > entries > entry1_');
    if (ent) {
        var entry = {
            id: ent.querySelector('id') && ent.querySelector('id').textContent,
            type: ent.querySelector('type') && ent.querySelector('type').textContent,
            title: ent.querySelector('name') && ent.querySelector('name').textContent,
            context_code: ent.querySelector('partnerData') && ent.querySelector('partnerData').textContent,
            mediaType: ent.querySelector('mediatype') && ent.querySelector('mediatype').textContent,
            entryId: ent.querySelector('id') && ent.querySelector('id').textContent,
            userTitle: undefined
        };
        return entry;
    }
    return null;
};
EntryService.prototype.onEntryRequestLoaded = function(e) {
    const entry = this.parseRequest(this.xhr.response);
    if (entry) {
        message_bus.dispatchEvent('Entry.success', entry, this);
    } else {
        message_bus.dispatchEvent('Entry.fail', this.xhr.response, this);
    }
};
const entry_service = EntryService;
;
function UiConfig(params) {
    this.fileFilters = [];
    this.maxUploads = params.maxUploads;
    this.maxFileSize = params.maxFileSize;
    this.maxTotalSize = params.maxTotalSize;
}
UiConfig.prototype.addFileFilter = function(fileFilter) {
    this.fileFilters.push(fileFilter);
};
UiConfig.prototype.filterFor = function(fileName) {
    let filter, f;
    const extension = fileName.split('.').pop();
    for(let i = 0, len = this.fileFilters.length; i < len; i++){
        f = this.fileFilters[i];
        if (f.includesExtension(extension)) {
            filter = f;
            break;
        }
    }
    return filter;
};
UiConfig.prototype.asEntryParams = function(fileName) {
    const currentFilter = this.filterFor(fileName);
    return currentFilter.toParams();
};
UiConfig.prototype.acceptableFileSize = function(fileSize) {
    return this.maxFileSize * 1024 * 1024 > fileSize;
};
UiConfig.prototype.acceptableFileType = function(fileName, types) {
    const currentFilter = this.filterFor(fileName);
    if (!currentFilter) {
        return false;
    }
    return types.indexOf(currentFilter.id) !== -1;
};
UiConfig.prototype.acceptableFile = function(file, types) {
    const type = this.acceptableFileType(file.name, types);
    const size = this.acceptableFileSize(file.size);
    return type && size;
};
const ui_config = UiConfig;
;
function FileFilter(params) {
    this.extensions = this.parseExtensions(params.extensions);
    this.id = params.id;
    this.description = params.description;
    this.entryType = params.entryType;
    this.mediaType = params.mediaType;
    this.type = params.type;
}
FileFilter.prototype.parseExtensions = function(extString) {
    return extString.split(';').map((ext)=>ext.substring(2));
};
FileFilter.prototype.includesExtension = function(extension) {
    return this.extensions.indexOf(extension.toLowerCase()) !== -1;
};
FileFilter.prototype.toParams = function() {
    const params = {
        entry1_type: this.entryType,
        entry1_mediaType: this.mediaType
    };
    return params;
};
const file_filter = FileFilter;
;
function filter_from_node(node) {
    return new file_filter({
        id: node.getAttribute('id'),
        description: node.getAttribute("description"),
        entryType: node.getAttribute('entryType'),
        mediaType: node.getAttribute('mediaType'),
        type: node.getAttribute('type'),
        extensions: node.getAttribute('extensions')
    });
}
;
function ui_config_from_node(xml) {
    const limits = xml.querySelector('limits');
    const config = new ui_config({
        maxUploads: limits.getAttribute('maxUploads'),
        maxFileSize: limits.getAttribute('maxFileSize'),
        maxTotalSize: limits.getAttribute('maxTotalSize')
    });
    const filters = xml.querySelectorAll('fileFilter');
    for(let i = 0, l = filters.length; i < l; i++){
        const filter = filter_from_node(filters[i]);
        config.addFileFilter(filter);
    }
    return config;
}
;
function UiconfService() {}
UiconfService.prototype.load = function(sessionSettings) {
    const data = sessionSettings.getSession();
    data.kalsig = signature_builder(data);
    this.xhr = new XMLHttpRequest();
    this.xhr.open('GET', k5_options.uiconfUrl + url_params(data));
    this.xhr.addEventListener('load', this.onXhrLoad.bind(this));
    this.xhr.send(data);
};
UiconfService.prototype.createUiConfig = function(xml) {
    this.config = ui_config_from_node(xml);
};
UiconfService.prototype.onXhrLoad = function(event) {
    const parser = new DOMParser();
    const conf = parser.parseFromString(this.xhr.response, "application/xml").querySelector("result > ui_conf > confFile").textContent;
    if (conf) {
        const configXML = parser.parseFromString(conf, "application/xml");
        this.config = ui_config_from_node(configXML);
        message_bus.dispatchEvent('UiConf.complete', this.config, this);
    } else {
        message_bus.dispatchEvent('UiConf.error', this.xhr.response, this);
    }
};
const uiconf_service = UiconfService;
;
function K5Uploader(options) {
    messenger.decorate(this);
    k5_options.setOptions(options);
    this.buildDependencies();
    this.addListeners();
    this.session.setSession(options.kaltura_session);
    this.loadUiConf();
}
K5Uploader.prototype.destroy = function() {
    message_bus.destroy();
    this.session = undefined;
    this.entryService = undefined;
    this.uiconfService = undefined;
};
K5Uploader.prototype.buildDependencies = function() {
    this.session = new kaltura_session();
    this.entryService = new entry_service();
    this.uiconfService = new uiconf_service();
};
K5Uploader.prototype.addListeners = function() {
    message_bus.addEventListener('UiConf.error', this.onUiConfError.bind(this));
    message_bus.addEventListener('UiConf.complete', this.onUiConfComplete.bind(this));
    message_bus.addEventListener('Uploader.error', this.onUploadError.bind(this));
    message_bus.addEventListener('Uploader.success', this.onUploadSuccess.bind(this));
    message_bus.addEventListener('Uploader.progress', this.onProgress.bind(this));
    message_bus.addEventListener('Entry.success', this.onEntrySuccess.bind(this));
    message_bus.addEventListener('Entry.fail', this.onEntryFail.bind(this));
};
K5Uploader.prototype.onSessionLoaded = function(data) {
    this.session = data;
    this.loadUiConf();
};
K5Uploader.prototype.loadUiConf = function() {
    this.uiconfService.load(this.session);
};
K5Uploader.prototype.onUiConfComplete = function(result) {
    this.uiconfig = result;
    this.dispatchEvent('K5.ready', {}, this);
};
K5Uploader.prototype.uploadFile = function(file) {
    this.file = file;
    if (!file) {
        return;
    }
    if (this.uiconfig.acceptableFile(file, k5_options.allowedMediaTypes) || [
        'webm',
        'video/webm',
        'audio/webm'
    ].includes(file.type)) {
        this.uploader = new uploader();
        this.uploader.send(this.session, file);
    } else {
        const details = {
            maxFileSize: this.uiconfig.maxFileSize,
            file,
            allowedMediaTypes: k5_options.allowedMediaTypes
        };
        this.dispatchEvent('K5.fileError', details, this);
    }
};
K5Uploader.prototype.onUploadSuccess = function(result) {
    const allParams = [
        this.session.asEntryParams(),
        result.asEntryParams(),
        k5_options.asEntryParams()
    ];
    this.entryService.addEntry(allParams);
};
K5Uploader.prototype.onProgress = function(e) {
    this.dispatchEvent('K5.progress', e, this);
};
K5Uploader.prototype.onUploadError = function(result) {
    this.dispatchEvent('K5.error', result, this);
};
K5Uploader.prototype.onEntrySuccess = function(data) {
    this.dispatchEvent('K5.complete', data, this);
};
K5Uploader.prototype.onEntryFail = function(data) {
    this.dispatchEvent('K5.error', data, this);
};
K5Uploader.prototype.onUiConfError = function(result) {
    this.dispatchEvent('K5.uiconfError', result, this);
};
export { K5Uploader };
